import { Injectable } from "@angular/core";
import { Observable } from "rxjs";


import { HeaderDetail } from '../models/header-detail';
import { ADPResourceService as ResourceService } from 'digital-core';
import { TokenService } from './token.service';
import { adpAPIService } from "./adp-api.service";
import { SendOTPRequest, User, VerifyOTPRequest } from "common";

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private adpAPIService: adpAPIService,
    private resourceService: ResourceService,
    private tokenService: TokenService) { }

  createUser(user: User): Observable<string> {
    let customHeaders: HeaderDetail[] = [];
    customHeaders.push(new HeaderDetail('x-AUL-Client-Id', this.resourceService.getPortalSetting('AUL_Client').Value));
    customHeaders.push(new HeaderDetail('Authorization', `Bearer ${this.tokenService.getTempIdToken()}`));

    return this.adpAPIService.postWithCustomHeaders<User, string>('URL_API_Users', user, customHeaders);
  }

  createUserToken(token): Observable<string> {
    return this.adpAPIService.post('URL_API_USERS_TOKEN', { token });
  }

  generateRefreshToken() {
    return this.adpAPIService.post('URL_API_USERS_REFRESH_TOKEN', null);
  }


  sendVertificationCode(request: SendOTPRequest): Observable<string> {
    // POC Code; there is issue with Assurant Azure web apps to connec to Twilio
    return this.adpAPIService.post('https://test-twilioservice.azurewebsites.net/api/v1/Users/SendVerificationCode', request);
  }

  verifyAccessCode(request: VerifyOTPRequest): Observable<string> {
    // POC Code; there is issue with Assurant Azure web apps to connec to Twilio
    return this.adpAPIService.post('https://test-twilioservice.azurewebsites.net/api/v1/Users/VerifyCode', request);
  }
}
